import React from 'react'

import { useCurrentSurvey } from '~/hooks/useCurrentSurvey'

/**
 * TAM比率を返すカスタムフックです。
 *
 * @returns TAM比率。
 */
export const useTamRatio = () => {
  const currentSurvey = useCurrentSurvey()

  return React.useMemo(() => {
    const tamNumber = currentSurvey.success
      ? (currentSurvey.value.metadata?.tamNumber ?? 0)
      : 0
    const numberOfTotalAnswers = currentSurvey.success
      ? (currentSurvey.value.numberOfTotalAnswers ?? NaN)
      : NaN

    return tamNumber === 0 ? 1 : tamNumber / numberOfTotalAnswers
  }, [currentSurvey])
}
